import { recorderWaveformMaxWidth } from '@mote/ui'
import styled from '@xstyled/styled-components'

export const padding = 12
export const horizontalPadding = `0 ${padding}px`
export const scrubberMaxWidth = recorderWaveformMaxWidth

export const CommonStyledScrubberWrapper = styled.div({
  width: '100%',
  maxWidth: scrubberMaxWidth,
  padding: horizontalPadding
})
